import { logError } from "@services/log-service";
import { useGlobalEnvConfig } from "@environment/GlobalEnvConfigProvider";

export const useItineraryService = () => {
  const { REACT_APP_API_DOMAIN } = useGlobalEnvConfig();

  const itineraryService = useItineraryServiceWithContext(REACT_APP_API_DOMAIN)

  const getBasisData = (itineraryIdentifier, includeBranding, operatoridentity) => {
    return itineraryService.getBasisData(itineraryIdentifier, includeBranding, operatoridentity)
  };

  const getBodyData = async (itineraryIdentifier) => {
    return itineraryService.getBodyData(itineraryIdentifier)
  };

  const trackView = async (itineraryIdentifier) => {
    return itineraryService.trackView(itineraryIdentifier)
  };

  const sendEnquiry = async (enquiryData, itineraryIdentifier, reCaptchaToken) => {
    return itineraryService.sendEnquiry(enquiryData, itineraryIdentifier, reCaptchaToken)
  };

  const getCrmContacts = async (itineraryIdentifier) => {
    return itineraryService.getCrmContacts(itineraryIdentifier)
  };

  return { getBasisData, getBodyData, trackView, sendEnquiry, getCrmContacts };
};


export const useItineraryServiceWithContext = (REACT_APP_API_DOMAIN) => {
  const getBasisData = (itineraryIdentifier, includeBranding, operatorIdentity) => {
    const params = new URLSearchParams();
    if (!includeBranding) params.append("includeBranding", "false");
    if (operatorIdentity) params.append("operatorIdentity", operatorIdentity);
    const queryString = params.toString();
    return fetch(`${REACT_APP_API_DOMAIN}/API/Itinerary/Basic/v2/Get/${itineraryIdentifier}${queryString ? `?${queryString}` : ""}`)
      .then((data) => data.json())
      .catch((error) =>
      logError(error, {
        location: "Itinerary",
      })
    );
  };

  const getBodyData = async (itineraryIdentifier) => {
    return fetch(`${REACT_APP_API_DOMAIN}/API/Itinerary/Basic/v2/GetExtendedContent/${itineraryIdentifier}`)
      .then((data) => data.json())
  };

  const trackView = async (itineraryIdentifier) => {
    const isMobile = window.screen.availWidth <= 768;
    return fetch(`${REACT_APP_API_DOMAIN}/API/Itinerary/MetaData/TrackView/${itineraryIdentifier}/${isMobile}`, {
      method: "POST",
      credentials: "include",
      headers: {
        "X-Wetu-Track": "42",
      },
    }).catch((error) =>
      logError(error, {
        location: "trackView",
      })
    );
  };

  const sendEnquiry = async (enquiryData, itineraryIdentifier, reCaptchaToken) => {
    return fetch(`${REACT_APP_API_DOMAIN}/API/MetaData/Enquire`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({
        Id: itineraryIdentifier,
        Name: enquiryData.name,
        Email: enquiryData.email,
        Telephone: enquiryData.telephone,
        ContactPreference: enquiryData.contact_preference,
        ArrivalDate: enquiryData.arrival_date,
        DepartureDate: enquiryData.departure_date,
        Message: enquiryData.message,
        NumOfAdults: enquiryData.number_of_adults,
        NumOfChildren: enquiryData.number_of_children,
        ReCaptchaToken: reCaptchaToken,
      }),
    }).catch((error) =>
      logError(error, {
        location: "sendEnquiry",
      })
    );
  };

  const getCrmContacts = async (itineraryIdentifier) => {
    return fetch(`${REACT_APP_API_DOMAIN}/Builder/Home/LoadItineraryTravellers?itineraryIdentifier=${itineraryIdentifier}`)
      .then((data) => data.json())
      .catch((error) =>
        logError(error, {
          location: "getCrmContacts",
        })
      );
  };

  return { getBasisData, getBodyData, trackView, sendEnquiry, getCrmContacts };
};

